import React from 'react';
import Categories from './BbCategories';
import './BbBannerShared.css';

class CategoriesNewGame extends React.Component {
  constructor(props) {
    super(props);
    this.handleCategorySelection = this.handleCategorySelection.bind(this);
  }

  handleCategorySelection(o) {
    this.props.handleCategorySelection(o);
  }

  render() {
    console.log('*** NEW GAME - SELECT CATS ***');

    return (
      <div className="container-fluid bg-secondary">
        <div className="row g-0">
          <div id="bb_waiting_new_game" className="col center">
            <h4>Select a category to start a new game!</h4>
          </div>
        </div>
        <div className="row g-0">
          <div className="col shadow-sm p-3 mb-5 bg-body rounded">
            <Categories
              cats={this.props.cats}
              roomKey={this.props.roomKey}
              roomName={this.props.roomName}
              onCategoriesChildChange={this.handleCategorySelection}
              key="welcomecatkeynewgame"
            />
          </div>
        </div>
      </div>
    );
  }
}
export default CategoriesNewGame;
